import React from 'react';

const SearchItems = () => {
    return (
        <div className="xl:w-96">
            <input
                type="search"
                className="
        form-control
        block
        w-full
        px-3
        py-1.5
        text-base
        font-normal
        text-gray-700
        bg-white bg-clip-padding
        border border-solid border-gray-300
        rounded
        transition
        ease-in-out
        m-0
        focus:text-gray-700 focus:bg-white focus:border-indigo-400 focus:outline-none
      "
                id="exampleSearch" name='query'
                placeholder="Search here..."
            />
        </div>
    );
};

export default SearchItems;